







import { Component, Vue } from 'vue-property-decorator'
import ViewDialog from '@/components/dialog/viewDialog.vue'
import h5player from '@/components/hikVideo/h5.vue'

@Component({
  components: {
    ViewDialog, h5player
  }
})
export default class PopH5Play extends Vue {
  public showDialog: boolean = false
  public loadPlayer: boolean = false

  public title: string = '视频播放'
  public vWidth: number = 600
  public vHeight: number = 400

  public $refs!: {
    refH5Player: any
  }

  public created() {
  }
  public mounted() {
    window.eventBus.$on("openH5Player", (
      opt: {
        title: string,
        code: string,
        playBack: boolean,
        storageType: number
      }) => {
      this.showDialog = true
      this.title = opt.title

      this.loadPlayer = false
      setTimeout(() => {
        this.loadPlayer = true
        this.$nextTick(() => {
          if (this.$refs.refH5Player) {
            this.$refs.refH5Player.h5SetOption({ code: opt.code, playBack: opt.playBack })
          }
        })
      }, 500)
    })
  }
  public beforeDestroy() {
    this.loadPlayer = false
    window.eventBus.$off("openH5Player")
  }
  public closeDialog() {
    this.loadPlayer = false
    this.showDialog = false
  }
  //#endregion
}
